module.exports = __webpack_public_path__ + "img/499.8f887938.png";